import {useQuery} from "@tanstack/react-query";
import Cookie from "js-cookie";
import config from "../../../../config";
import {ONE_TRUST_FEATURE_FLAG} from "../constants";

export const useFeatureFlags = () => {
  const {data, ...rest} = useQuery({
    queryKey: ["featureFlags"],
    queryFn: () => {
      const cookie = Cookie.get(config.features.storageKey);
      const cookieFlags = cookie ? JSON.parse(cookie) : {};

      return new Map(cookieFlags);
    },
    staleTime: Infinity,
  });

  return {
    flags: data || new Map(),
    ...rest,
  };
};

/**
 * @param {string} featureFlagName
 */
export const useFeatureFlag = featureFlagName => {
  const {flags} = useFeatureFlags();
  const flagId = config.features.flags[featureFlagName];

  return flagId && flags.get(flagId);
};
